export * from "./SharedInputComponent";
export { InputMixin, V3InputLabel, } from "./SharedInputComponent.styles";
export type { InputStyleProps } from "./SharedInputComponent.styles";
